import { atom } from "recoil";

export const kakaoModalState = atom({
  key: "home-kakao-modal",
  default: false,
});
